import variables from "@/config/variables";
export const APP_NAME = "ReFlowConnect";
export const CORE_SERVICE_BASE_URL = variables.CORE_SERVICE_BASE_URL;
export const WE_AID_SERVICE_BASE_URL = variables.WE_AID_SERVICE_BASE_URL;
export const MEDIA_MART_BASE_URL = variables.MEDIA_MART_BASE_UR;
export const EBAY_LISTING_BASE_URL = variables.EBAY_LISTING_BASE_URL;
export const EBAY_LISTED_ITEM_BASE_URL = variables.EBAY_LISTED_ITEM_BASE_URL;
export const SAND_BOX_EBAY_BASE_URL = variables.SAND_BOX_EBAY_BASE_URL;
export const SUPPORT_URLS = {
  SHAREPOINT: "https://mediasaturn.sharepoint.com/sites/DEU-Store-Processes/SitePages/ReFlow-Connect.aspx",
};

export const SUPPORT_PHONES = {
  EBAY_CONCIERGE: "033203 851021",
  EBAY_ACCOUNT: "033203 851310",
};

export const SUPPORT_EMAILS = {
  TECHNICAL: "it.reflowconnect@i-ways.net",
  MMSD_STORE_PROCESSES: "mmsd.store.processes@mediamarktsaturn.de",
  EBAY_CONCIERGE: "customerhelp_de@ebay.com",
  EBAY_ACCOUNT: "msd@ebay.de",
  MIRAKL: "mms.partner.de@mms-marketplace.com",
};

export const MARKET_PLACES = {
  EBAY: "eBay",
  MIRAKL: "Mirakl",
};

export const MARKETPLACE_LOGOS = {
  EBAY: "/assets/ebaylogo.png",
  MIRAKL: "/assets/mirakl-logo.png",
};
export const MARKETPLACE_IDS = {
  EBAY: "ebay",
  MIRAKL: "mirakl",
  EBAY_MIRAKL: "ebay-mirakl",
};

export const SHIPPING_HANDLING_TYPES = {
  TWO_MH: "TWO_MH",
  PARCEL: "PARCEL",
  NULL: null,
};
export const APP_STORE_SLICES = {
  BULK_UPLOAD: {
    OFFER_DETAILS: "bulkUploadOfferDetails",
  },
  EASY_LISTER: {
    ARTICLE_LISTING: "articleListing",
  },
};
export const SCOPE_OF_DELIVERY_MAX_LENGTH = 65;
export const CONDITION_DESCRIPTION_MAX_LENGTH = 250;
export const EBAY_TITLE_MAX_LENGTH = 80;
export const PROCESSING_TIME_MAX_LIMIT = 20;
export const DEFAULT_EBAY_CONDITION_ID = 1000;
export const CONDITION_ID_MAP = {
  Neu: {
    idField: "conditionIDNeu",
    nameField: "conditionNeu",
  },
  "Neu Sonstiges": {
    idField: "conditionIDNeuSonstige",
    nameField: "conditionNeuSonstige",
  },
  Gebraucht: {
    idField: "conditionIDGebraucht",
    nameField: "conditionGebraucht",
  },
};
export const EBAY_ITEM_CONDITION = {
  NEW: "Neu",
  REFURBISHED: "Refurbished",
  PACKAGE_DAMAGED: "Verpackung beschädigt",
};
export const SHIPPING_TYPES = {
  DHL_SHIPPING: "DHL Versandkosten",
  SPEDITON_SHIPPING: "Speditons-Versandkosten",
};

export const TABLE_IDS = {
  ERROR_LOGS: "ERROR_LOGS_TABLE",
  ORDER_LISTING: "ORDER_LISTING_TABLE",
  OUTLET_LISTING: "OUTLET_LISTING_TABLE",
};
export const CONDITION_DESCRIPTION = {
  NEW: "Der Artikel ist neu und originalverpackt",
};
export const DATA_TYPES = {
  STRING: "string",
  OBJECT: "object",
};
export const PRODUCT_ASSET_TYPE = {
  MANUFACTURER_IMAGE: "Manufacturer Image",
  PRODUCT_IMAGE: "Product Image",
  FEATURE_ASSET: "Feature Asset",
};
export const STORAGE_KEYS = {
  AUTH_STORAGE: "auth-storage",
};
export const USER_ROLES = {
  SUPER_USER: "superUser",
  SELLER: "seller",
};
export const ROUTE_ROLES = {
  SETTINGS: [USER_ROLES.SUPER_USER],
};
export const QUERY_KEYS = {
  ITEM_CONDITIONS: "itemConditions",
  DISCOUNT_PROFILES_BY_PRODUCT_ID: "discountProfilesByProductId",
  EASY_LISTER_DATA: "easy-lister-data",
  SHIPPING_COSTS: "shipping-costs",
};
export const PAYMENT_STATUS = {
  PAID: "Paid",
};
export const HANDLING_TYPE_TO_SHIPPING_TYPE = {
  [SHIPPING_HANDLING_TYPES.TWO_MH]: "FLAT",
  [SHIPPING_HANDLING_TYPES.PARCEL]: "FLAT",
  [SHIPPING_HANDLING_TYPES.NULL]: "FLAT",
};
export const SHIPPING_METHOD = {
  FLAT: "DE_DHLPaket",
  FREIGHT_FLAT: "DE_DHLPaket",
};
export const HANDLING_TYPE_TO_SHIPPING_METHOD = {
  [SHIPPING_HANDLING_TYPES.TWO_MH]: "DE_DHLPaket",
  [SHIPPING_HANDLING_TYPES.PARCEL]: "DE_DHLPaket",
};
export const ASSORTMENT_FLAGS = {
  OA: "OA",
  OUT: "OUT",
  EOL: "EOL",
  PRO: "PRO",
};

export const PATH_NAMES = {
  ORDERS: "orders",
  LISTINGS: "listings",
  RETURNS: "returns",
  OUTLETS: "outlets",
};

export const PROCESSING_TIME_VALUES = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
];

export const HIDDEN_RETURN_STATUSES = {
  READY_FOR_SHIPPING: "READY_FOR_SHIPPING",
  CLOSED: "CLOSED",
  LESS_THAN_A_FULL_REFUND_ISSUED: "LESS_THAN_A_FULL_REFUND_ISSUED",
  RETURN_REJECTED: "RETURN_REJECTED",
};
export const STATS_KEYS = {
  TOTAL_ONLINE_EBAY_ITEM_COUNT: "totalOnlineEbayItemCount",
  TOTAL_ONLINE_MIRAKL_ITEM_COUNT: "totalOnlineMiraklItemCount",
  EBAY_ORDERS_COMPLETED_COUNT: "ebayOrdersCompletedCount",
  MIRAKL_ORDERS_COMPLETED_COUNT: "miraklOrdersCompletedCount",
  TOTAL_EBAY_ORDER_SALES_PRICE: "totalEbayOrderSalesPrice",
  TOTAL_EBAY_RETURN_COMPLETED_COUNT: "totalEbayReturnCompletedCount",
  TOTAL_MIRAKL_RETURN_COMPLETED_COUNT: "totalMiraklReturnCompletedCount",
  TOTAL_EBAY_RETURN_PERCENTAGE: "totalEbayReturnPercentage",
  TOTAL_MIRAKL_RETURN_PERCENTAGE: "totalMiraklReturnPercentage",
  TOTAL_MIRAKL_ORDER_SALES_PRICE: "totalMiraklOrderSalesPrice",
};

export const HREFS = {
  LISTING_OVERVIEW_HREF: "listings/overview/?ebayCondition=all",
  RETURNS_LISTING_HREF: "returns/return-listing/?returnsFilterType=COMPLETED",
  ORDERS_LISTING_HREF:
    "orders/order-listing/?ebayOrderFilterType=COMPLETED_ORDERS",
};

export const SEARCH_PARAMS = {
  EBAY_ORDER_FILTER_TYPE: "ebayOrderFilterType",
};

export const HOVER_EFFECT = {
  HOVER_GRAY: "hover:shadow-[0_0_16px_#DADADA]",
  SHADOW_GRAY: "shadow-[0_0_16px_#DADADA]",
};

export const INVALID_SHIPPING_TIMES = [10, 15, 20];

export const TEXT_REPLACEMENTS = {
  LINK_REMOVED: "link entfernt",
};

export const HAS_SEARCH = true;

export const ORDER_STATUS_DISPLAY_TO_INTERNAL = {
  Verschickt: "TRACKING_SUCCESS",
  Versandfertig: "READY_TO_SHIP",
  Abgeholt: "PICKED_UP",
  "Versandlabel erstellt": "SHIPPING_LABEL_CREATED",
  Abgebrochen: "CANCELLED",
  Abgeschlossen: "COMPLETED",
  Storniert: "CANCELED",
  "Extern bearbeitet": "EXTERNALLY_HANDLED",
};

export const ORDER_STATUS_VALUES = {
  ORDER_STATUS: "orderStatus",
};

export const PRICE_CHANGE_TIME = {
  REFERENCE_TIME: 1776948884139,
};

export const API_FILTER_DTO_STATUSES = {
  ALL: "all",
  CLOSED: "closed",
};

export const ACTIVE_STAT_CONDITIONS = {
  EBAY_CONDITION: "ebayCondition",
  MARKETPLACE: "marketplace",
  CONDITION: "condition",
};

export const STATS_ORDER = [
  "notAcceptedOrderCounts",
  "documentNotCreatedForOrderCounts",
  "documentNotCollectedForOrderCounts",
  "shippingLabelNotUploadOrderCounts",
  "readyForDispatchOrderCounts",
  "completedOrderCounts",
  "allEbayOrders",
  "allDueOrders",
  "canceledOrderCounts",
];
